// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-list[data-v-4cb5aeac] {\n  border: 1px solid #e8eef1;\n  border-radius: 6px;\n}\n.project-input-container[data-v-4cb5aeac] {\n  min-height: 50px;\n  max-height: 200px;\n  overflow: auto;\n  overflow-x: hidden;\n}", ""]);
// Exports
module.exports = exports;
